// extracted by mini-css-extract-plugin
export default {"content":"TermsPage_content__wKUzK","page_title":"TermsPage_page_title__bx-dR","page_text":"TermsPage_page_text__T9px+"};